// extracted by mini-css-extract-plugin
export default {"buttonWrap":"RadioButtons_buttonWrap__4jpTJ","pText":"RadioButtons_pText__EXk86","label":"RadioButtons_label__+Tf8s","radio":"RadioButtons_radio__4bQZk"};